<template>
  <div>
    <div class="page-content">
      <p class="nav-spec">{{pageTitle}}</p>

      <p class="tips">{{pageTips}}</p>

      <div class="userid-box">
        <p class="title-text">{{title}}</p>
        <p class="value-text">{{content}}</p>
      </div>

      
      <p class="tips-2">Please take a screenshot to save the information</p>
      <!-- <SaveImage></SaveImage> -->

      <p class="tips-1">{{$t('APP-FIELD-0136')}}
        <span class="hot-line" @click="hotLineShow = true">{{$t('APP-FIELD-0137')}}</span>
      </p>

      <div class="bottom-wrap">
        <el-button @click="$emit('on-next')" type="primary">{{btnText}}</el-button>
      </div>
    </div>

    <services-hot-line v-model="hotLineShow" :agencyBanking="agencyBanking"></services-hot-line>
  </div>
</template>

<script>
  import ServicesHotLine from "../components/ServicesHotLine";
  // import SaveImage from "../components/SaveImage";

  export default {
    name: "IdAndPassword",
    components: {
      ServicesHotLine,
      // SaveImage
    },

    props: {
      title: {
        type: String,
        default: ""
      },
      content:{
        type: String,
        default: ""
      },
      
      btnText: {
        type: String,
        default: "Next"
      },

      isPwd: {
        type: Boolean,
        default: false
      },

      agencyBanking: {
        type: Boolean,
        default: false
      },
    },

    created() {
      if(!this.isPwd) {
        this.pageTitle = this.$t('APP-FIELD-0198')
        this.pageTips = this.$t('APP-FIELD-0199')
      }else {
        this.pageTitle = this.$t('APP-FIELD-0200')
        this.pageTips = this.$t('APP-FIELD-0201')
      }
    },

    data() {
      return {
        hotLineShow: false
      }
    },

    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    text-align: center;
    width: 700px;
    margin: 0 auto;

    .success-icon {
      margin: 20px 0;
      width: 77px;
    }

    .nav-spec {
      font-family: Nunito-Bold;
      font-size: 32px;
      color: #2C405A;
      letter-spacing: 0.16px;
      text-align: center;
      margin-bottom: 20px;
    }

    .tips {
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #2C405A;
      letter-spacing: 0.09px;
      text-align: center;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .userid-box {
      width: 380px;
      height: 120px;
      background: #E5F5FF;
      border-radius: 8px;
      margin: 30px auto 32px;
      padding: 24px 0 26px 0;

      .title-text {
        font-family: Nunito-Regular;
        font-size: 16px;
        color: #2C2C2C;
        letter-spacing: 0;
        text-align: center;
      }
      .value-text {
        font-family: Nunito-Bold;
        font-size: 24px;
        color: #2C2C2C;
        letter-spacing: 0;
        text-align: center;
        margin-top: 15px;
        font-weight: bold;
      }
    }

    .save-img-box {
      text-align: center;

      img {
        width: 24px;
        margin-right: 10px;
        vertical-align: middle;
      }

      span {
        font-family: Nunito-SemiBold;
        font-size: 16px;
        color: #0072D8;
        letter-spacing: 0.14px;
      }
    }

    .tips-1 {
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #2C405A;
      letter-spacing: 0.09px;
      margin: 20px auto;

    }

    .hot-line {
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #61C0FA;
      letter-spacing: 0.08px;
      text-align: center;
      line-height: 24px;
      cursor: pointer;
    }

    .tips-2{
      font-family: Nunito-Regular;
      font-size: 16px;
      color: #2C405A;
      letter-spacing: 0.08px;
      text-align: center;
      line-height: 24px;
      margin: 20px auto ;
    }

    .el-button {
      width: 223px;
    }
  }
</style>